var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"padless":"","color":"secondary","dark":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('strong',[_vm._v("SVDMQE")]),_vm._v(". © "+_vm._s(_vm.anno)+". Caracas, Venezuela ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }